import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[scrollSpy]' })
export class ScrollSpyDirective {
  @Input() public spiedTags: any[] = [];
  @Output() public sectionChange = new EventEmitter<string>();
  private currentSection!: string;
  _offset = 0;

  constructor(private _el: ElementRef) {}

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    let currentSection = '';
    const children = this._el.nativeElement.children[0].children[1].children;
    const scrollTop = event.target.scrollTop;
    const parentOffset = event.target.offsetTop;
    for (let i = 0; i < children.length; i++) {
      const element = children[i];
      if (this.spiedTags.some((spiedTag) => spiedTag === element.tagName)) {
        console.log(
          `${element.id} - Offset: ${
            element.offsetTop - parentOffset
          }, Scroll top: ${scrollTop}`
        );
        if (element.offsetTop - parentOffset - this._offset <= scrollTop) {
          currentSection = element.id;
        }
      }
    }
    if (currentSection != this.currentSection) {
      this.currentSection = currentSection;
      this.sectionChange.emit(this.currentSection);
    }
  }
}
